'use client';
import { useState } from 'react';
import clsx from 'clsx';
import { Typography } from '@bgzt/ui';
import { findShop } from '~/utils/shop-service';
import { utilStyles } from '~/styles';
import styles from './ShopDescription.module.css';

type Props = {
  shopId: string;
};
export const ShopDescription = ({ shopId }: Props) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      <div className={styles.container}>
        <div className={clsx(styles.description, !showAll && utilStyles.doubleLineEllipticalText)}>
          <Typography variant="B5" color="gray-900">
            {findShop(shopId)?.about ?? ''}
          </Typography>
        </div>
        <button type="button" onClick={() => setShowAll(!showAll)}>
          <Typography variant="B5" color="gray-400" className={styles.showAllButtonText}>
            {showAll ? '접기' : '펼치기'}
          </Typography>
        </button>
      </div>
    </>
  );
};
